/**
 * What a viewer sees when a boundary catches a render crash. Kept in its own file
 * so AppErrorBoundary exports only the boundary class.
 *
 * Themed with tokens rather than fixed colours: `primary` is Recruit41 orange on
 * `:root`, and the `.assessment-*` skins redefine it, so a crash inside a themed
 * assessment still looks like the page it replaced.
 */
export function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-xl font-semibold text-foreground">
          Something went wrong
        </h1>
        <p className="mb-6 text-muted-foreground">
          This page stopped responding. Reloading usually fixes it. If it keeps
          happening, contact support.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-2xl bg-primary px-6 py-3 text-sm font-bold text-primary-foreground hover:brightness-105"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}
